import { SHOT_FOOTAGE_IDENTIFIER } from "@/env";
import { SourceEnum, ProjectFiles } from "@/__generated__/graphql";

export interface CustomBidLiteFormValues {
  source: SourceEnum;
  folderPath: string;
  downloadInfo: string;
  files: File[];
  projectFiles: ProjectFiles[];
}

export interface Shot {
  __typename: "Shot";
  id: string;
  name: string;
  frameCount: number | null;
  defaultReferenceFrameKeys: (string | null)[];
  frameKeys: (string | null)[];
  videoStorageKey: string | null;
}

/**
 * Format shot footage name.
 * @param shot a GraphQL Shot result
 *
 * NOTE: DO NOT change the formatting. The backend uses it to determine
 * reference media is actually shot footage.
 */
export const getShotFootageName = (shot: Shot) => {
  const { name, frameCount } = shot;
  if (!frameCount) {
    return `${name} ${SHOT_FOOTAGE_IDENTIFIER}`;
  }
  return `${name}-0-${frameCount} ${SHOT_FOOTAGE_IDENTIFIER}`;
};
